import { GDPR_COOKIE_NAME } from "@circle-react/components/constants";
import { REQUIRED_COUNTRIES } from "@circle-react/components/GDPR/GDPRCookieBanner/requiredCountries";
import { useCookies } from "react-cookie";

const FALSE_BOOLEAN_VALUES = new Set([
  "0",
  "f",
  "F",
  "false",
  "FALSE",
  "off",
  "OFF",
]);

const circleConsentGiven = (value: unknown) => {
  if (
    value === null ||
    value === undefined ||
    value === false ||
    value === 0 ||
    (typeof value === "string" && value.trim() === "")
  )
    return false;

  if (typeof value === "string") return !FALSE_BOOLEAN_VALUES.has(value);
  return true;
};

const cookieYesAnalyticsConsentGiven = (value: unknown) => {
  const cookieValue = typeof value === "string" ? value : "";
  const cookiePairs = cookieValue
    .split(",")
    .map((pair): string[] => pair.split(":", 2).map(part => part.trim()))
    .filter((parts): parts is [string, string] => parts.length === 2);
  const cookieValues: Record<string, string> = Object.fromEntries(cookiePairs);

  return cookieValues.analytics?.toLowerCase() === "yes";
};

export const useConversionTrackingConsent = (): boolean => {
  const [cookies] = useCookies([GDPR_COOKIE_NAME, "cookieyes-consent"]);
  const countryCode = window.CLOUDFLARE_COUNTRY_CODE ?? "";

  if (!Object.hasOwn(REQUIRED_COUNTRIES, countryCode)) return true;

  return (
    circleConsentGiven(cookies[GDPR_COOKIE_NAME]) ||
    cookieYesAnalyticsConsentGiven(cookies["cookieyes-consent"])
  );
};
